import { useState, type ReactElement, type ReactNode } from 'react';

interface BrandLogoProps {
  /** URL логотипа заведения (brandLogoUrl(branding)); пусто — без логотипа */
  src: string | undefined;
  /** Название заведения */
  alt: string;
  /** Размеры и скругление; пропорции сохраняются (object-contain) */
  className?: string;
  /** Что показать без логотипа или если он не загрузился (по умолчанию — ничего) */
  fallback?: ReactNode;
  /** Обёртка вокруг картинки (полоса с логотипом) — скрывается вместе с ней */
  frame?: (img: ReactElement) => ReactElement;
}

/**
 * Логотип заведения (white-label: загружается в кабинете, бэкенд отдаёт logoUrl). Битая картинка не показывается:
 * при ошибке загрузки — запасной вариант; новый адрес (логотип сменили) пробуется снова.
 */
export function BrandLogo({ src, alt, className = '', fallback = null, frame }: BrandLogoProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (!src || failedSrc === src) return <>{fallback}</>;

  const img = (
    <img
      src={src}
      alt={alt}
      className={`object-contain ${className}`.trim()}
      decoding="async"
      onError={() => setFailedSrc(src)}
    />
  );
  return frame ? frame(img) : img;
}
